module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.order && _vm.orderFound) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    抱歉，没有查到相关订单\n  ")]) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.order.products), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(g.unit || '斤'))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (g.quantity),
        expression: "g.quantity"
      }],
      staticClass: "quantity",
      domProps: {
        "value": (g.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(g, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== _vm.order.supplier) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.order.roughPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.dueTime))])]), _vm._v(" "), (_vm.order.notes) ? _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order._id))])]), _vm._v(" "), (_vm.order.createTime) ? _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("filterTime")(_vm.order.createTime)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.STATUS_MAP[_vm.order.status]))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("供应商")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.supplier),
      expression: "order.supplier"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.order, "supplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.suppliers), function(supplier) {
    return _c('option', {
      key: supplier._id,
      domProps: {
        "value": supplier._id
      }
    }, [_vm._v(_vm._s(supplier.name))])
  })], 2)])])]), _vm._v(" "), (_vm.order.status == 2 || _vm.order.status == 1) ? _c('div', {
    staticClass: "bottom-options"
  }, [(_vm.order.status == 1) ? _c('p', {
    staticClass: "order-to-pay"
  }, [_c('span', {
    staticClass: "pay",
    on: {
      "click": function($event) {
        return _vm.orderConfirm()
      }
    }
  }, [_vm._v("确认提交")])]) : _vm._e(), _vm._v(" "), (_vm.order.status == 2) ? _c('p', {
    staticClass: "order-to-pay"
  }, [_c('span', {
    staticClass: "pay",
    on: {
      "click": function($event) {
        return _vm.orderConfirm()
      }
    }
  }, [_vm._v("再次确认")])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-412cf1f5"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportOrderDetail.vue
// module id = 538
// module chunks = 1